
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  SupplierAccountParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierAccountParameters.ts

import {Address } from "./Address";
import {Currency } from "./Currency";
export class SupplierAccountParameters {

  // int Id
  public Id: number=0;

  // int PayCurId
  public PayCurId: number=0;

  // int OrderCurId
  public OrderCurId: number=0;

  // byte TopAffacturage
  public TopAffacturage: number=0;

  // string AffacturageName
  public AffacturageName?: string=null;

  // string AffacturageSiret
  public AffacturageSiret?: string=null;

  // string AffacturagePhone
  public AffacturagePhone?: string=null;

  // string AffacturageContactName
  public AffacturageContactName?: string=null;

  // string AffacturageEmail
  public AffacturageEmail?: string=null;

  // int? AddrFacId
  public AddrFacId?: number=null;

  // byte TopFacDemat
  public TopFacDemat: number=0;

  // string FacSendEmail
  public FacSendEmail?: string=null;

  // string FacReturnEmail
  public FacReturnEmail?: string=null;

  // string PaySendEmail
  public PaySendEmail?: string=null;

  // int RefStep
  public RefStep: number=0;

  // string LngCod
  public LngCod?: string=null;

  // string RoutageEmail
  public RoutageEmail?: string=null;

  // string RoutageCod
  public RoutageCod?: string=null;

  // bool? TopRFE
  public TopRFE?: boolean=null;

  // Address FacAddress
  public FacAddress: Address=null;

  // Currency OrderCurrency
  public OrderCurrency: Currency=null;

  // Currency PayCurrency
  public PayCurrency: Currency=null;
}